import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { IssuesContainer } from 'src/features/issues/containers/issues';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/tenant/issues/')({
  component: IssuesContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
